
// Data for Water Analytics charts and visualizations

export const consumptionData = [
  { name: 'Jan', consumption: 310 },
  { name: 'Feb', consumption: 290 },
  { name: 'Mar', consumption: 320 },
  { name: 'Apr', consumption: 330 },
  { name: 'May', consumption: 340 },
  { name: 'Jun', consumption: 380 },
  { name: 'Jul', consumption: 420 },
  { name: 'Aug', consumption: 430 },
  { name: 'Sep', consumption: 400 },
  { name: 'Oct', consumption: 350 },
  { name: 'Nov', consumption: 320 },
  { name: 'Dec', consumption: 310 },
];

export const pressureData = [
  { time: '00:00', pressure: 3.8 },
  { time: '02:00', pressure: 3.9 },
  { time: '04:00', pressure: 3.85 },
  { time: '06:00', pressure: 4.0 },
  { time: '08:00', pressure: 4.1 },
  { time: '10:00', pressure: 4.2 },
  { time: '12:00', pressure: 4.1 },
  { time: '14:00', pressure: 4.0 },
  { time: '16:00', pressure: 3.95 },
  { time: '18:00', pressure: 4.15 },
  { time: '20:00', pressure: 4.05 },
  { time: '22:00', pressure: 3.9 },
];

export const flowData = [
  { time: '00:00', flow: 12 },
  { time: '02:00', flow: 10 },
  { time: '04:00', flow: 8 },
  { time: '06:00', flow: 15 },
  { time: '08:00', flow: 22 },
  { time: '10:00', flow: 18 },
  { time: '12:00', flow: 20 },
  { time: '14:00', flow: 17 },
  { time: '16:00', flow: 16 },
  { time: '18:00', flow: 21 },
  { time: '20:00', flow: 18 },
  { time: '22:00', flow: 14 },
];

export const waterDistribution = [
  { name: 'Bathroom', value: 40 },
  { name: 'Kitchen', value: 25 },
  { name: 'Laundry', value: 20 },
  { name: 'Outdoor', value: 10 },
  { name: 'Other', value: 5 },
];

export const COLORS = ['#0EA5E9', '#7DD3FC', '#38BDF8', '#BAE6FD', '#E0F2FE'];

export const recentAlarms = [
  { id: 1, device: 'Main Water Line', issue: 'Pressure Spike', severity: 'High', time: '1 hour ago' },
  { id: 2, device: 'Bathroom Supply', issue: 'Leakage Detected', severity: 'Medium', time: '6 hours ago' },
  { id: 3, device: 'Irrigation System', issue: 'Low Pressure', severity: 'Low', time: '1 day ago' },
  { id: 4, device: 'Water Heater', issue: 'Flow Disruption', severity: 'Medium', time: '2 days ago' },
];

export const getSeverityColor = (severity: string) => {
  switch (severity) {
    case 'High': return 'text-energy-red';
    case 'Medium': return 'text-amber-500';
    case 'Low': return 'text-energy-green';
    default: return 'text-gray-500';
  }
};
